import React from "react"

import Layout from "../components/Layout/index"
import { uiReducer, initialUIModel, UIModel, UIAction } from "../store/ui"
import {
  arbeidReducer,
  initialArbeidModel,
  ArbeidModel,
  ArbeidAction,
} from "../store/arbeid"
import { useReducer } from "reinspect"
import {
  publiseringReducer,
  initialPubliseringModel,
  PubliseringModel,
  PubliseringAction,
} from "../store/publisering"
import App from "../components/App"

interface Props {
  arbeidState: ArbeidModel
  arbeidDispatch: React.Dispatch<ArbeidAction>
  uiState: UIModel
  uiDispatch: React.Dispatch<UIAction>
  publiseringState: PubliseringModel
  publiseringDispatch: React.Dispatch<PubliseringAction>
}

function IndexContainer(props: Props) {
  return (
    <Layout uiState={props.uiState} uiDispatch={props.uiDispatch}>
      <App {...props} />
    </Layout>
  )
}

function ProductionAppWrapper() {
  const [uiState, uiDispatch] = React.useReducer(uiReducer, initialUIModel)
  const [arbeidState, arbeidDispatch] = React.useReducer(
    arbeidReducer,
    initialArbeidModel
  )
  const [publiseringState, publiseringDispatch] = React.useReducer(
    publiseringReducer,
    initialPubliseringModel
  )
  return (
    <IndexContainer
      uiState={uiState}
      uiDispatch={uiDispatch}
      arbeidState={arbeidState}
      arbeidDispatch={arbeidDispatch}
      publiseringState={publiseringState}
      publiseringDispatch={publiseringDispatch}
    />
  )
}

function DevelopmentAppWrapper() {
  const [uiState, uiDispatch] = useReducer(
    uiReducer,
    initialUIModel,
    state => state,
    "UI"
  )
  const [arbeidState, arbeidDispatch] = useReducer(
    arbeidReducer,
    initialArbeidModel,
    state => state,
    "ARBEID"
  )
  const [publiseringState, publiseringDispatch] = useReducer(
    publiseringReducer,
    initialPubliseringModel,
    state => state,
    "PUBLISERING"
  )
  return (
    <IndexContainer
      uiState={uiState}
      uiDispatch={uiDispatch}
      arbeidState={arbeidState}
      arbeidDispatch={arbeidDispatch}
      publiseringState={publiseringState}
      publiseringDispatch={publiseringDispatch}
    />
  )
}

export default function Index() {
  if (process.env.NODE_ENV === "production") {
    return <ProductionAppWrapper />
  } else {
    return <DevelopmentAppWrapper />
  }
}
